module.exports = __webpack_public_path__ + "media/recipes/125-790fa0b2.png";